import React,{useState,useEffect} from 'react';
import Image from "../../../assets";
import CustomText,{
  getFontSize,
  getFontWeight,
} from '../../components/CustomText';
import CustomTextInput from '../../components/CustomTextInput';
import CustomButton from '../../components/CustomButton';
import Color from "../../../utils/Color";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  labelTextInputTextStyle: {
    fontWeight:400,
    fontSize:16,
    color: '#171717',
  },
  textInputContainer: {
    height: 48,
    marginBottom: 25,
    marginTop: 5,
    width:'260px'
  },
  headerTextStyle: {
    fontWeight:700,
    fontSize: 20,
    textAlign: "left",
    color: "#333333",
  },
  inputContentContainer: {
    marginTop: '1.5rem',
    marginBottom: 10,
    display:'flex',
    alignItems:'center',
    width:'100%',
    gap:'10px',
    justifyContent:'space-between'
  },
  backButton: {
    width: 120,
    marginTop: 0,

    borderColor: Color.primaryTextColor,
    backgroundColor: "transparent",
    color: Color.primaryTextColor,
    opacity: 0.6,
    "&:hover": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
    },
    "&:focus": {
      color: "white",
      backgroundColor: Color.blackButtonColor,
      opacity: 1.0,
    },
  },
  backButtonTextStyle: {
    fontFamily: "Muli",
    ...getFontSize("medium"),
    ...getFontWeight("bold"),
  },
  buttonStyle:{
    //width:'100%'
    height:'48px',
    maxWidth:'101px'
    // width:'30%'
  }
}));

const RetrieveOptionSec = ({ setPage }) => {
  const {passportNo, setPassportNo} = useState('');
  const classes = useStyles();

  const onChangePassportNo = (event) => {
    setPassportNo(event.target.value.toUpperCase())
  };

  const onClickNext = () => {

  }
  return (
    <div style={{paddingTop:"3.5rem",paddingLeft:'2.2rem',paddingRight:'2.2rem'}}>
      <div style={{color:'#333333',fontSize:'20px',fontWeight:'700'}}>Retrieve your account for registration</div>
      <div style={{color:'#000000',fontSize:'14px',fontWeight:'400',marginTop:'2rem'}}>For customers who have NRIC/FIN</div>
      <div style={{marginTop:'1.5rem'}}><img src={Image.contSingpass} style={{width:'100%',height:54,cursor:'pointer'}} 
      //onClick={() => setPage('RetrieveOptionFir')}
      onClick={() => setPage('MobileOtp')}
      />
      </div>
      <div style={{borderBottom:'1px solid #CBCBCB80',paddingTop:'1.5rem'}}></div>
      <div style={{fontSize:'14px',color:'#000000',marginTop:'1.5rem'}}>or for customers who <span style={{textDecoration:'underline',fontWeight:'500'}}>do not have</span> NRIC/FIN, please retrieve your account via</div>
      <div className={classes.inputContentContainer}>
      <CustomTextInput
          title={"Passport Number"}
          textstyle={classes.labelTextInputTextStyle}
          design={classes.textInputContainer}
          fullWidth={true}
          value={passportNo}
          onChange={onChangePassportNo}
        />
         <CustomButton
          title={"Retrieve"}
          design={classes.buttonStyle}
          onClick={onClickNext}
        />
      </div>
      <div style={{fontSize:'14px',marginTop:'1.5rem'}}>By continuing, you acknowledged and agree to Etiqa’s <span style={{color:'#FFBC00',fontWeight:'500'}}>Terms of Use.</span></div>
      {/* <button onClick={() => setPage('MobileOtp')}>Go to Mobile OTP</button> */}
    </div>
  );
};

export default RetrieveOptionSec;